/* Keiiarra Essence theme JS */
(function () {
  'use strict';

  /* ---- Mobile nav ---- */
  var nav = document.querySelector('[data-nav]');
  var scrim = document.querySelector('.nav-scrim');
  document.querySelectorAll('[data-nav-open]').forEach(function (b) {
    b.addEventListener('click', function () {
      nav.classList.add('is-open');
      if (scrim) scrim.hidden = false;
      b.setAttribute('aria-expanded', 'true');
    });
  });
  document.querySelectorAll('[data-nav-close]').forEach(function (b) {
    b.addEventListener('click', function () {
      nav.classList.remove('is-open');
      if (scrim) scrim.hidden = true;
    });
  });

  /* ---- Day-arc hero: tint by local time ---- */
  var hero = document.querySelector('[data-day-arc]');
  if (hero) {
    var h = new Date().getHours();
    var slot = h < 11 ? 'morning' : h < 16 ? 'midday' : h < 19 ? 'afternoon' : h < 21 ? 'evening' : h < 23 ? 'night' : 'twilight';
    var idx = { morning: 0, midday: 1, afternoon: 2, evening: 3, night: 4, twilight: 5 }[slot];
    hero.setAttribute('data-hour', slot === 'morning' ? 'dawn' : slot === 'afternoon' ? 'midday' : slot === 'evening' ? 'dusk' : slot === 'twilight' ? 'night' : slot);
    var dot = hero.querySelector('[data-arc="' + idx + '"]');
    if (dot) dot.classList.add('is-now');
    var greet = hero.querySelector('[data-day-greeting]');
    if (greet) {
      var g = { morning: 'The mood that starts the day', midday: 'Clean skin, fresh mood', afternoon: 'The unhurried hours', evening: 'The hour the day exhales', night: 'Romance for both', twilight: 'Evening without labels' };
      greet.textContent = g[slot];
    }
  }





  /* ---- Toast ---- */
  var toastEl = null;
  function ktoast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'ktoast'; document.body.appendChild(toastEl); }
    toastEl.textContent = msg;
    toastEl.classList.add('show');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('show'); }, 2400);
  }



  /* ---- AJAX add to cart (keeps pages fast, no reload) ---- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form || !form.querySelector('[data-ajax-add]')) return;
    e.preventDefault();
    var btn = form.querySelector('[data-ajax-add]');
    var old = btn.textContent;
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function () { return fetch('/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        var cc=document.getElementById('cartCount'); if(cc)cc.textContent=cart.item_count;
        var fb=document.getElementById('fabCart'); if(fb&&cart.item_count>0)fb.classList.add('show');
        btn.textContent = 'Added ✓';
        setTimeout(function () { btn.textContent = old; }, 1600);
      })
      .catch(function () {
        btn.textContent = old;
        form.submit(); /* graceful fallback */
      });
  });

  /* ---- Collection mood filter ---- */
  var grid = document.querySelector('[data-collection-grid]');
  document.querySelectorAll('[data-mood-filter]').forEach(function (chip) {
    chip.addEventListener('click', function () {
      document.querySelectorAll('[data-mood-filter]').forEach(function (c) { c.classList.remove('is-active'); });
      chip.classList.add('is-active');
      var mood = chip.getAttribute('data-mood-filter');
      grid.querySelectorAll('[data-mood-item]').forEach(function (item) {
        item.style.display = (mood === 'all' || item.getAttribute('data-mood-item') === mood) ? '' : 'none';
      });
    });
  });

  /* ---- Mood quiz ---- */
  var quiz = document.querySelector('[data-quiz]');
  if (quiz) {
    var mapEl = quiz.querySelector('[data-quiz-map]');
    var map = mapEl ? JSON.parse(mapEl.textContent) : {};
    var score = { dawn: 0, midday: 0, dusk: 0, night: 0 };
    var qs = quiz.querySelectorAll('.quiz__q');
    var current = 0;
    quiz.querySelectorAll('.quiz__opt').forEach(function (opt) {
      opt.addEventListener('click', function () {
        score[opt.getAttribute('data-pts')]++;
        qs[current].classList.remove('is-active');
        current++;
        if (current < qs.length) {
          qs[current].classList.add('is-active');
        } else {
          var winner = Object.keys(score).sort(function (a, b) { return score[b] - score[a]; })[0];
          var r = map[winner] || {};
          var res = quiz.querySelector('[data-quiz-result]');
          quiz.querySelector('[data-quiz-title]').textContent = r.title || '';
          quiz.querySelector('[data-quiz-copy]').textContent = r.copy || '';
          var link = quiz.querySelector('[data-quiz-link]');
          if (r.url) link.href = r.url; else link.hidden = true;
          res.hidden = false;
        }
      });
    });
  }

  /* ---- Golden Vial video popup ---- */
  var vv = document.querySelector('[data-vv]');
  if (vv) {
    var overlay = vv.querySelector('[data-vv-overlay]');
    var video = vv.querySelector('[data-vv-video]');
    var openVV = function () {
      overlay.hidden = false;
      document.body.style.overflow = 'hidden';
      if (video) { video.play().catch(function () {}); }
    };
    var closeVV = function () {
      overlay.hidden = true;
      document.body.style.overflow = '';
      if (video) video.pause();
    };
    vv.querySelector('[data-vv-open]').addEventListener('click', openVV);
    vv.querySelectorAll('[data-vv-close]').forEach(function (b) { b.addEventListener('click', closeVV); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !overlay.hidden) closeVV(); });
    /* swipe down to dismiss */
    var startY = null;
    overlay.addEventListener('touchstart', function (e) { startY = e.touches[0].clientY; }, { passive: true });
    overlay.addEventListener('touchend', function (e) {
      if (startY !== null && e.changedTouches[0].clientY - startY > 90) closeVV();
      startY = null;
    }, { passive: true });
    /* optional auto-open, once per session */
    var delay = parseInt(vv.getAttribute('data-delay') || '0', 10);
    if (delay > 0 && !sessionStorage.getItem('kv-vv-seen')) {
      setTimeout(function () {
        sessionStorage.setItem('kv-vv-seen', '1');
        openVV();
      }, delay * 1000);
    }
  }


})();
